import React, { FC } from "react";
import { EMPTY_STRING } from "../../common/constants/common.constants";
import { CreateClubWizardSteps } from "../../common/enums/clubs-wizard.enum";
import { ISellPermissionConfig } from "../../common/interfaces/clubs.interface";
import SellPermissions from "../ClubDetails/AboutClub/ClubConfiguration/SellPermissions/SellPermissions";
import PreviewComponent from "../CreateClubWizard/ClubPreview/PreviewComponent";
import edit from "../../assets/edit.svg";
import "./VotingConfiguration.scss";

const VotingConfiguration: FC<{
  defaultVotingQuorum: number;
  defaultMaxVotingTime: number;
  mintSymbol: string;
  mintDecimals: number;
  tradeRanges: boolean;
  transferVotingQuorum?: number | string; //We need to set this to be string also, since the formik by default set it to empty string if some value is deleted
  transferMaxVotingTime?: number;
  withdrawalVotingQuorum?: number | string;
  withdrawalMaxVotingTime?: number;
  showEditVoting: boolean;
  clubConfigMaxVotingTime?: number | string;
  clubConfigQuorum?: number | string;
  sellPermissionConfig?: {
    permissions: ISellPermissionConfig[];
    permissionsAmount: number;
    divideByLamports: boolean;
  };
  isClubCreation?: boolean;
  modifySection?: (sectionStep: CreateClubWizardSteps) => void;
}> = ({
  showEditVoting,
  defaultMaxVotingTime,
  defaultVotingQuorum,
  transferMaxVotingTime,
  transferVotingQuorum,
  withdrawalMaxVotingTime,
  withdrawalVotingQuorum,
  isClubCreation,
  clubConfigMaxVotingTime,
  clubConfigQuorum,
  sellPermissionConfig,
  modifySection,
  mintSymbol,
  tradeRanges,
  mintDecimals,
}) => {
  return (
    <div className="voting-config">
      <div className="voting-config__header">
        <p className="voting-config__title">Voting configuration</p>
        {isClubCreation && showEditVoting && (
          <img
            src={edit}
            className="preview-component__edit-icon"
            alt="Edit icon"
            onClick={() =>
              modifySection &&
              modifySection(CreateClubWizardSteps.FinancialConfiguration)
            }
          />
        )}
      </div>
      <PreviewComponent
        showEditIcon={false}
        label={EMPTY_STRING}
        previewContent={[
          { title: "Voting quorum", description: `${defaultVotingQuorum} %` },
          {
            title: "Max voting time",
            description: `${defaultMaxVotingTime} days`,
          },
        ]}
      />
      {withdrawalVotingQuorum !== undefined &&
        withdrawalVotingQuorum !== EMPTY_STRING &&
        withdrawalMaxVotingTime && (
          <PreviewComponent
            showEditIcon={false}
            label={"Withdrawal configuration"}
            previewContent={[
              {
                title: "Voting quorum",
                description: `${withdrawalVotingQuorum} %`,
              },
              {
                title: "Max voting time",
                description: `${withdrawalMaxVotingTime} days`,
              },
            ]}
          />
        )}
      {transferMaxVotingTime &&
        transferVotingQuorum !== undefined &&
        transferVotingQuorum !== EMPTY_STRING && (
          <PreviewComponent
            showEditIcon={false}
            label={"Transfer configuration"}
            previewContent={[
              {
                title: "Voting quorum",
                description: `${transferVotingQuorum} %`,
              },
              {
                title: "Max voting time",
                description: `${transferMaxVotingTime} days`,
              },
            ]}
          />
        )}

      <PreviewComponent
        showEditIcon={false}
        label={"Change club configuration"}
        previewContent={[
          {
            title: "Voting quorum",
            description: `${clubConfigQuorum} %`,
          },
          {
            title: "Max voting time",
            description: `${clubConfigMaxVotingTime} days`,
          },
        ]}
      />

      {sellPermissionConfig && (
        <div className="club-preview__sell-permissions">
          <SellPermissions
            showEditIcon={isClubCreation}
            onEditIconClick={() =>
              modifySection &&
              modifySection(CreateClubWizardSteps.FinancialConfiguration)
            }
            divideByLamports={sellPermissionConfig.divideByLamports}
            permissionsAmount={sellPermissionConfig.permissionsAmount}
            permissions={sellPermissionConfig.permissions}
            mintSymbol={mintSymbol}
            tradeRanges={tradeRanges}
            mintDecimals={mintDecimals}
          />
        </div>
      )}
    </div>
  );
};

export default VotingConfiguration;
